import { Layout, Menu } from "antd";
import { Button, Icon } from "components/common";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.less";
import { getMenuItems } from "./menuItems";

const AppLayout = ({ children }) => {
  const menuItemsList = useMemo(() => getMenuItems(), []);
  const [activeItem, setActiveItem] = useState([menuItemsList[0].key]);
  const { Sider } = Layout;
  const [collapsed, setCollapsed] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const findMenuItem = menuItemsList.find((e) =>
      window.location.pathname.includes(e.key)
    );
    if (findMenuItem?.key) {
      setActiveItem([findMenuItem.key]);
    } else {
      setActiveItem([menuItemsList?.[0].key]);
    }
  }, [window.location.pathname, menuItemsList]);

  return (
    <Layout className={styles.appLayout}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className={styles.sideNav}
      >
        <div className={styles.appInfo}>
          <Button
            style={{ background: "#F3FBFF" }}
            icon="SiderBarCollpaseIcon"
            iconProps={{ size: "18px" }}
            onClick={() => setCollapsed(!collapsed)}
          />
          {!collapsed && <Icon icon={"IllnessLogo"} />}
        </div>
        <Menu
          className={styles.sideNavMenu}
          mode="inline"
          items={menuItemsList}
          selectedKeys={activeItem}
          defaultSelectedKeys={activeItem}
          onClick={(item) => {
            navigate(item.key);
            setActiveItem([item.key]);
          }}
        />
      </Sider>
      {children}
    </Layout>
  );
};

export default AppLayout;
